var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92892 19.0711C1.02367 15.1658 1.02367 8.83418 4.92892 4.92893C8.83416 1.02369 15.1658 1.02369 19.0711 4.92893C22.9763 8.83418 22.9763 15.1658 19.0711 19.0711C15.1658 22.9763 8.83416 22.9763 4.92892 19.0711ZM6.21457 6.21458C3.01937 9.40978 3.01937 14.5902 6.21457 17.7854C9.40977 20.9806 14.5902 20.9806 17.7854 17.7854C20.9806 14.5902 20.9806 9.40978 17.7854 6.21458C14.5902 3.01938 9.40977 3.01938 6.21457 6.21458ZM8.78586 8.78588C9.14088 8.43086 9.71649 8.43086 10.0715 8.78588L12 10.7144L13.9285 8.78588C14.2835 8.43086 14.8591 8.43086 15.2141 8.78588C15.5691 9.1409 15.5691 9.7165 15.2141 10.0715L13.2856 12L15.2141 13.9285C15.5691 14.2835 15.5691 14.8591 15.2141 15.2141C14.8591 15.5691 14.2835 15.5691 13.9285 15.2141L12 13.2856L10.0715 15.2141C9.71649 15.5691 9.14088 15.5691 8.78586 15.2141C8.43084 14.8591 8.43084 14.2835 8.78586 13.9285L10.7143 12L8.78586 10.0715C8.43084 9.71651 8.43084 9.1409 8.78586 8.78588Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.59efeeccea0b941814decfbe856d6f8f.svg";
export { ForwardRef as ReactComponent };